import { Button } from '@mantine/core';
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { If } from '@vision/ui/components';
import { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import classes from './FilterAreaBackButton.module.css';

export function FilterAreaBackButton() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const enabled = useMemo(() => {
    return window.history.state.idx !== 0;
  }, [window.history.state]);

  const navigateBack = () => {
    navigate(-1);
  };

  return (
    <If value={enabled}>
      <Button
        data-testid="button-filter-area-back"
        variant="transparent"
        onClick={navigateBack}
        classNames={{ root: classes.filterAreaBackButton }}
        leftSection={<FontAwesomeIcon icon={faAngleLeft} className={classes.icon} />}
      >
        {t('back')}
      </Button>
    </If>
  );
}
